// src/components/cognition/cognition-page-header.tsx
import React from "react";
import { Brain } from "lucide-react";

export function CognitionPageHeader() {
  return (
    <div
      className="px-8 md:px-16 py-6 md:py-8 border-b"
      style={{ borderColor: "var(--border)", backgroundColor: "var(--background)" }}
    >
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Brain className="w-5 h-5 shrink-0" style={{ color: "var(--muted-foreground)" }} />
        <span
          style={{
            fontSize: "var(--text-sm)",
            color: "var(--muted-foreground)",
            fontWeight: "var(--font-weight-medium)",
          }}
        >
          AI Reasoning Path
        </span>
      </div>

      <div className="mb-3 md:mb-4">
        <h2
          style={{
            fontSize: "clamp(var(--text-xl), 4.5vw, var(--text-2xl))",
            fontWeight: "var(--font-weight-semibold)",
            color: "var(--foreground)",
            lineHeight: "1.3",
          }}
        >
          Understand how AIs think. Fix what shapes perception.
        </h2>
      </div>

      <p
        style={{
          color: "var(--muted-foreground)",
          fontSize: "var(--text-base)",
          marginBottom: 20,
        }}
      >
        See how each AI model interprets your query, gathers evidence, evaluates your product, and constructs its final recommendation.
      </p>

      {/* Metadata Row: wraps onto multiple lines on narrow screens */}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <div className="flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full shrink-0"
            style={{ backgroundColor: "var(--alpha-teal)" }}
          />
          <span style={{ fontSize: "var(--text-sm)", color: "var(--muted-foreground)" }}>
            4-stage reasoning pipeline
          </span>
        </div>

        <div className="flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full shrink-0"
            style={{ backgroundColor: "var(--signal-blue)" }}
          />
          <span style={{ fontSize: "var(--text-sm)", color: "var(--muted-foreground)" }}>
            Multi-model analysis
          </span>
        </div>
      </div>
    </div>
  );
}